import React from "react";
import { Button } from "components/button";
import { PaperWorkEstimateCard } from "components/PaperWorkEstimateCard";
import "./valuationInfo.scss"
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { isMobile } from "core/utils";
import { CardLayout } from "components/cardLayout";
import { logo, info, truckDelivery } from 'assets/images';
export interface PaperWorkEstimateProps {
    onClick?(): void;
    formControl?: FormControl;
}

export interface PaperWorkEstimateState {

}

class ValuationInfo extends React.Component<PaperWorkEstimateProps, PaperWorkEstimateState> {
    constructor(props: PaperWorkEstimateProps) {
        super(props);
        this.state = {};
    }
    handleContinue() {
        if (this.props.onClick) {
            this.props.onClick()
        }
    }
    render() {
        return (
            <div className="todo-container">
                <div className={"paperContainer"} style={{ height: window.innerHeight - 150 }}>
                    <div className="gap short" />
                    <div className="paperworkEst-title">
                        <h1>Protecting Your<br />Household Belongings</h1>
                    </div>
                    <div className="paperworkEst-title" style={{ fontSize: 16, lineHeight: "40px", verticalAlign: 'middle' }}>
                        Selecting Valuation Options <img style={{ display: 'inline-block', color: '#0B9A64' }} src={info} />
                    </div>

                    <CardLayout>
                        <div style={{ fontSize: 16 }}>
                            <b>Valuation Protection</b> <u>is not insurance</u>, but the value you declare for your shipment and the maximum coverage and liability of All My Sons if your belongings are lost, damagers, or destroyed!
                        </div>
                    </CardLayout>

                    <CardLayout>
                        <div style={{ fontSize: 16 }}>
                            <div className="customCardContainer">
                                <div className="page-title">Typical Coverage Options</div>
                            </div>
                            <div className="container-block">
                                <div className="container-half-block">
                                    <div className="container-title-block1">Limited Liability</div>
                                    <div className="container-list">
                                        <ul>
                                            <li>
                                                <div className="container-icon"><img src={truckDelivery} /></div>
                                                <div className="container-title" style={{ color: "#3A7C63", textTransform: "uppercase" }}>No Charge!</div>
                                            </li>
                                            <li>
                                                <div className="container-icon"><img src={truckDelivery} /></div>
                                                <div className="container-title" style={{ textTransform: "uppercase" }}>Included in your move!</div>
                                            </li>
                                            <li>
                                                <div className="container-icon"><img src={truckDelivery} /></div>
                                                <div className="container-title" style={{ textTransform: "uppercase" }}>Reimburses your items at 60 cents per pound, per item.
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="container-half-block" style={{ borderRight: "none" }}>
                                    <div className="container-title-block2">Full Value Protection</div>
                                    <div className="container-list">
                                        <ul>
                                            <li>
                                                <div className="container-icon"><img src={truckDelivery} /></div>
                                                <div className="container-title" style={{ textTransform: "uppercase" }}><span style={{ color: "#3A7C63" }}>Additional Charge </span><br />based on shipment value declared!</div>
                                            </li>
                                            <li>
                                                <div className="container-icon"><img src={truckDelivery} /></div>
                                                <div className="container-title" style={{ borderRight: "none", textTransform: "uppercase" }}>Selected by Choice!</div>
                                            </li>
                                            <li>
                                                <div className="container-icon"><img src={truckDelivery} /></div>
                                                <div className="container-title" style={{ borderRight: "none", textTransform: "uppercase" }}>Damaged goods repaired or compensated at current
                                                    replacement value.</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="my-20 font-bold text-center color-red" style={{ fontSize: 16, textTransform: "uppercase" }}>How might this claim be compensated?</div>
                                <div className="container-hightlighter">
                                    <div className="container-half-hightlighter" style={{ color: "#0B9A64", borderRight: '1px solid #9E9E9E', width: '50%' }}>
                                        <div style={{ paddingRight: 15 }}>Limited:</div>
                                        <div>$30</div>
                                    </div>
                                    <div className="container-half-hightlighter" style={{ color: "#3A7C63" }}>
                                        <div style={{ paddingRight: 15 }}>FVP:</div>
                                        <div>$500</div>
                                    </div>
                                </div>
                                <div style={{ borderBottom: "1px solid #9E9E9E", marginBottom: 10 }}>
                                    <div className="my-20 font-bold text-center color-red" style={{ fontSize: 16, textTransform: "uppercase" }}>Example:</div>
                                    <div className="font-600 my-20 text-center" style={{ fontSize: 16 }}>A 50lb. TV with a current replacement value of $500 is
                                        destroyed!</div>
                                </div>

                                <div style={{ padding: 24 }} >
                                    <img src={logo} className="" alt="logo" style={{ height: 70, margin: "0 auto" }} />
                                </div>

                                <div className="color-red text-center" style={{ fontSize: 16, textTransform: "uppercase" }}>High-Value items & “3<sup style={{ textTransform: "lowercase" }}>rd</sup> Party Insurance” Options, please contact your
                                    Salesperson</div>
                            </div>
                        </div>
                    </CardLayout>
                    <br />
                </div>

                <Button
                    text={"Continue"}
                    onClick={() => this.handleContinue()}
                />
            </div>
        );
    }
}

export default ValuationInfo;